<div class="modal-header">
    <button aria-label="Close" class="close" data-dismiss="modal" type="button" (click)="close()" #closeButton>
        <span aria-hidden="true"> × </span>
    </button>
</div>
<div class="modal-body">
    <ng-template [ngIf]="searchPharmacyStep == 1">
        <div class="pharmacies">

            <div class="card-header">
                <h2 class="title"> Nearest Pharmacies </h2>
                <span>
                    You can select one from below recommendation or use the search to find another one.
                </span>

                <div class="search pr-3 mt-3 ">
                    <input class="search-p" type="text" name="search" id="src_txt" placeholder="Type Pharmacy name..."
                        (keyup.enter)="searchPharmacy($event.target.value)">
                    <i class="fa fa-search"></i>
                </div>
                <!-- <hr class="mb-4"> -->
            </div>

            <div class="pharmacy-list mt-2 p-3">

                <div class="card small-card pointer" *ngFor="let pharmacy of pharmacyList"
                    (click)="onSelectPharmacy(pharmacy)">
                    <div class="small-card-body p-3">

                        <h3 class="m-0"> {{pharmacy.name}} - {{pharmacy.address | slice:0:15}}... </h3>
                        <span>
                            <i class="icon-eye"></i>
                        </span>
                    </div>
                </div>

                <h3 class="text-center" *ngIf="pharmacyList.length == 0">There is no Available Pharmacies in
                    this area now</h3>


            </div>
        </div>
    </ng-template>
    <ng-template [ngIf]="searchPharmacyStep == 2">
        <div class="card card-sp pharmacies">

            <div class="card-header ph-details">
                <div class="link d-flex align-items-center pointer" (click)="searchPharmacyStep = 1">
                    <span><i class="icon-left-arrow"></i></span>
                    <h5> Back To Pharmacies</h5>
                </div>
                <h2 class="title"> {{selectedPharmacy.name}} - {{selectedPharmacy.address}} </h2>
                <span>
                </span>
            </div>
            <div class="card-body pharmacy-det ">
                <h1 class="mb-2 mt-4"> Pharmacy Details </h1>
                <div class="data-card ">
                    <div class="data-container mt-3 ">
                        <h2>Location</h2>
                        <div class="row">
                            <div class="data col-6">
                                <h6>City</h6>
                                <h4>{{selectedPharmacy?.city?.name}}</h4>
                            </div>
                            <div class="data col-6">
                                <h6>Area</h6>
                                <h4>{{selectedPharmacy?.area?.name}}</h4>
                            </div>

                        </div>
                        <div class="row mt-3">
                            <div class="data col-12">
                                <h6>Address</h6>
                                <h4>{{selectedPharmacy?.address}}</h4>
                            </div>
                        </div>


                        <hr>
                        <h2>Contact Information</h2>
                        <div class="row">

                            <div class="data col-6" *ngIf="selectedPharmacy?.phone">
                                <h6>Pharmacy Number 1</h6>
                                <h4>{{selectedPharmacy?.hotline}} <span class="pointer"
                                        (click)="copyToClipboard(selectedPharmacy?.hotline)"><i
                                            class="icon-copy"></i></span></h4>
                            </div>
                            <div class="data col-6">
                                <h6>Pharmacy Number 2</h6>
                                <h4>{{selectedPharmacy?.phone }} <span class="pointer"
                                        (click)="copyToClipboard(selectedPharmacy?.phone)"><i
                                            class="icon-copy"></i></span></h4>
                            </div>
                        </div>


                    </div>
                </div>

            </div>
            <div class="card-footer">
                <div class="row step-footer mt-4 mb-5">
                    <div class="col-6">
                        <button type="submit" class="btn outline btn-round" (click)="searchPharmacyStep = 1"> Select Another
                            Pharmacy </button>
                    </div>
                    <div class="col-6">
                        <button type="submit" class="btn btn-psp-primary btn-round"
                            [disabled]="selectedPharmacy.id == 0" (click)="confirmRouteToPharmacy(closeButton)"> Pharmacy
                            Confirmed Order!
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
